import React, { useRef, useEffect, useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import AOS from "aos";
import "aos/dist/aos.css";
import { getBlogs } from "../firebase"; // Adjust path if needed
import { useNavigate } from "react-router-dom";
import { Divide } from "lucide-react";

function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  // Fetch blogs from Firebase
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogs = await getBlogs();
        setBlogPosts(blogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  // Scroll buttons
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  // Initialize AOS animations
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <section className="bg-white py-8 text-center">
      <h2 data-aos="fade-up" className="text-3xl lg:text-4xl font-bold text-[#3471B8] mb-2">
        <span className="text-[#3471B8] font-manrope">Blogs</span>
      </h2>
      <p
        data-aos="fade-up"
        className="text-[#343434] font-manrope text-medium text-[16px] mb-10 max-w-xl mx-auto"
      >
        Whether it is about the latest style or industry insights, stay tuned to our source of information here
      </p>

      <div
        data-aos="zoom-out"
        className="relative w-full pl-4 pr-0 md:py-2 md:pl-12 md:pr-0"
      >
        {/* Left Arrow */}
        <button
          onClick={scrollLeft}
          className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white hover:bg-blue-100 text-blue-800 rounded-full shadow p-2 transition duration-200"
        >
          <HiChevronLeft size={24} />
        </button>

        {/* Scrollable Blog Cards */}
        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide scrollbar-hidden scroll-smooth px-0"
        >
          {blogPosts.map((blog, index) => (
            <div
              key={index}
              className="min-w-[300px] max-w-[320px] bg-blue-50 rounded-xl overflow-hidden text-left shadow-sm hover:shadow-md transition flex-shrink-0"
            >
              <img
                src={blog.imageUrl}
                alt=""
                className="w-full h-40 object-cover"
              />
              <div className="p-4">
                {blog.createdAt?.seconds && (
                  <p className="text-[14px] text-[#343434] font-manrope mb-2">
                    {new Date(blog.createdAt.seconds * 1000).toLocaleDateString(
                      "en-US",
                      { day: "2-digit", month: "short", year: "numeric" }
                    )}
                  </p>
                )}
                <div className="text-[16px] font-manrope text-[#343434] mb-3 leading-snug line-clamp-2"
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />


                <button
                  onClick={() =>
                    navigate(`/blog/${blog.urlKey}`, { state: { data: blog } })
                  }
                  className="text-sm text-blue-600 font-medium hover:underline"
                >
                  Read More →
                </button>
              </div>
            </div>

        ))}

        </div>

        {/* Right Arrow */}
        <button
          onClick={scrollRight}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white hover:bg-blue-100 text-blue-800 rounded-full shadow p-2 transition duration-200"
        >
          <HiChevronRight size={24} />
        </button>
      </div>
    </section>
  );
}

export default BlogPage;
